module.exports = __webpack_public_path__ + "static/media/cert_12487.1fd8b2f7.jpg";